// Conteúdo da landing page.
// Textos, labels, subtítulos e CTAs seguem 'BlackBelt IT Solutions - Site em 23092026.html'.
// Dados factuais (falas dos depoimentos, números, links) vêm do site atual.

export const WHATSAPP_URL =
  'https://api.whatsapp.com/send/?phone=558184393531&text&type=phone_number&app_absent=0';

export const navItems = [
  { label: 'Início', href: '#inicio' },
  { label: 'Quem Somos', href: '#quem-somos' },
  { label: 'Soluções', href: '#solucoes' },
  { label: 'CyberSensei', href: '#cybersensei' },
  { label: 'Depoimentos', href: '#depoimentos' },
  { label: 'Mídia', href: '#midia' },
];

export const hero = {
  badge: 'Somos Faixa Preta em Cibersegurança',
  titleStart: 'Protegendo sua empresa com',
  titleHighlight: 'estratégia',
  subtitle: 'Segurança da Informação, Privacidade de Dados e Cloud Services com presença em todo o território nacional.',
  secondaryButton: 'Saiba Mais',
  primaryButton: 'Agendar Avaliação',
};

export const stats = [
  { value: '500+', label: 'Empresas atendidas' },
  { value: '97%', label: 'de recomendação entre clientes' },
  { value: '15+', label: 'Anos de experiência' },
  { value: '1000+', label: 'Ativos protegidos' },
];

export const about = {
  tag: 'Institucional',
  title: 'Autoridade e Solidez em Segurança Digital',
  subtitle: 'Combinamos metodologia de faixa preta e tecnologia de ponta para blindar operações corporativas.',
  lead: {
    before: 'Somos uma empresa especializada em serviços, soluções e treinamentos em ',
    strong: 'Segurança da Informação e Privacidade de Dados',
    after: ', com presença abrangente em todo o território nacional.',
  },
  text:
    'Nossa experiência consolidada e parcerias estratégicas com renomados fabricantes mundiais nos permitem proteger seu negócio de maneira eficaz, resiliente e em total conformidade regulatória.',
  pillars: [
    { icon: 'shield', title: 'Defesa Proativa', desc: 'Antecipação contínua de ameaças' },
    { icon: 'clock', title: 'Conformidade LGPD', desc: 'Mitigação total de riscos e sanções' },
  ],
  award: {
    tag: 'Reconhecimento Nacional',
    title: 'Prêmio Sebrae Startups',
    text: 'Destaque entre as principais soluções inovadoras de cibersegurança e privacidade do ecossistema brasileiro.',
    // Link do selo Sebrae no site atual.
    link: 'https://programas.sebraestartups.com.br/in/premiosebraestartups',
  },
};

export const segmentsSection = {
  tag: 'Mercados & Verticais',
  title: 'Quem Ajudamos',
  subtitle: 'Soluções sob medida para setores de alta criticidade e exigência de conformidade regulatória.',
};

export const segments = [
  { icon: 'government', title: 'Instituições Governamentais' },
  { icon: 'health', title: 'Entidades de Saúde' },
  { icon: 'industry', title: 'Indústria e Engenharia' },
  { icon: 'entertainment', title: 'Entretenimento e Lazer' },
  { icon: 'advertising', title: 'Publicidade e Propaganda' },
  // Inclui "Funerário", presente no site atual e omitido na referência.
  { icon: 'services', title: 'Serviços (Jurídico, Contábil, Funerário)' },
  { icon: 'technology', title: 'Empresas de Tecnologia' },
  { icon: 'education', title: 'Instituições de Ensino' },
];

export const solutionsSection = {
  tag: 'Nossas Áreas de Atuação',
  title: 'Soluções Estratégicas e Resilientes',
  subtitle: 'Pilares fundamentais para transformar riscos cibernéticos em vantagem competitiva.',
};

export const solutions = [
  {
    icon: 'shield',
    pillar: 'Pilar 01',
    title: 'Segurança da Informação',
    description:
      'Conjunto abrangente de serviços, soluções e treinamentos para alcançar o mais alto nível de Segurança da Informação, com equipe multidisciplinar para tornar seu negócio mais resiliente e sustentável.',
    link: 'https://drive.google.com/file/d/1cYtCPoC63IdWS4cSbdyjwSlx8tXbIoQp/view',
  },
  {
    icon: 'lock',
    pillar: 'Pilar 02',
    title: 'Privacidade e Governança (LGPD)',
    description:
      'Auxílio no cumprimento dos requisitos legais de compliance da LGPD, com abordagem dinâmica para tornar sua empresa mais competitiva, proteger dados sensíveis e evitar severas sanções de órgãos fiscalizadores.',
    link: 'https://drive.google.com/file/d/12qsDxFaM5gSzDAIkJTds1H_f32-LldMC/view',
  },
  {
    icon: 'cloud',
    pillar: 'Pilar 03',
    title: 'BBIT Cloud Services',
    description:
      'Implantação e manutenção de infraestruturas de Cloud Computing: Cloud Deployment, Gestão Financeira (FinOps) e Automação e Segurança de Estruturas (DevSecOps) para alta disponibilidade contínua.',
    // O site atual não tinha material de Cloud: usa o link de WhatsApp da referência.
    link: 'https://api.whatsapp.com/send/?phone=558184393531&text=Ola!%20Gostaria%20de%20saber%20mais%20sobre%20os%20servicos%20de%20BBIT%20Cloud%20Services.',
  },
];

export const cyberSensei = {
  pill: 'Plataforma Gamificada',
  titleStart: 'Conheça a',
  titleHighlight: 'CyberSensei',
  text:
    'A plataforma inovadora desenvolvida pela BlackBelt que democratiza a cibersegurança nas organizações. Transformamos seus colaboradores na primeira linha ativa de defesa contra ameaças digitais.',
  features: [
    { title: 'Treinamentos Interativos:', text: 'Conteúdo envolvente com linguagem acessível a qualquer perfil profissional.' },
    { title: 'Simulações de Ataques Reais:', text: 'Testes periódicos de phishing e engenharia social controlados.' },
    { title: 'Desafios Práticos Gamificados:', text: 'Métricas de engajamento, ranking e evolução contínua da cultura segura.' },
  ],
  button: 'Conheça a CyberSensei',
  link: 'https://cybersensei.com.br/',
  badgeTitle: 'Cultura de Defesa Humana',
  // A referência cita "Mais de 85%" sem fonte; o percentual foi retirado até ser confirmado.
  badgeText:
    'A maioria das brechas de segurança inicia no fator humano. A CyberSensei capacita sua equipe como verdadeiros faixas-pretas em detecção de golpes.',
  badgeChip: 'Integração Rápida · Relatórios em Tempo Real',
};

export const testimonialsSection = {
  tag: 'Casos de Sucesso',
  title: 'O Que Nossos Clientes Dizem',
  subtitle: 'A confiança de quem conta com a proteção estratégica da BlackBelt IT Solutions no dia a dia.',
};

export const testimonials = [
  {
    initials: 'HG',
    name: 'Hugo Galvão',
    role: 'Supervisor de TI na Fricon',
    quote:
      'A BlackBelt nos conduziu com maestria por todo o processo de conformidade com a LGPD e consolidação da nossa infraestrutura de segurança. A competência técnica e a prontidão da equipe nos deram total tranquilidade operacional.',
  },
  {
    initials: 'FG',
    name: 'Fábio Gomes',
    role: 'CTO Diorama Digital',
    quote:
      'Para uma empresa que lida com ativos digitais e propriedade intelectual crítica, ter a BlackBelt como parceira é indispensável. O suporte estratégico em segurança da informação nos colocou em padrão internacional.',
  },
  {
    initials: 'JS',
    name: 'José Luiz Silva',
    role: 'Gerente de TI no Vila',
    quote:
      'A abordagem da BlackBelt vai além de ferramentas: eles realmente capacitam a empresa e transformam a maturidade da TI. A mitigação de vulnerabilidades foi imediata e o atendimento é impecável.',
  },
];

export const mediaSection = {
  tag: 'Repercussão & Artigos',
  title: 'Na Mídia',
  subtitle: 'Presença ativa no debate sobre o futuro da cibersegurança, privacidade e inovação tecnológica.',
};

export const media = [
  {
    tag: 'Destaque',
    title: 'Startup de professor da Unit-PE é uma das maiores do Brasil',
    ariaPrefix: 'Ler notícia',
    link: 'https://pe.unit.br/blog/noticias/startup-de-professor-da-unit-pe-e-uma-das-maiores-do-brasil/',
  },
  {
    tag: 'Podcast',
    title: 'BlackBelt IT Solutions e Segurança da Informação',
    ariaPrefix: 'Assistir podcast',
    link: 'https://www.youtube.com/watch?v=dJ5U78EoEvw&t=2s',
  },
  {
    tag: 'LGPD',
    title: 'Empresas do Nordeste enfrentam desafios para adequação à LGPD',
    ariaPrefix: 'Ler reportagem',
    link: 'https://movimentoeconomico.com.br/internet/2025/01/29/empresas-do-ne-enfrentam-desafios-para-adequacao-a-lgpd/',
  },
  {
    tag: 'Evento',
    title: 'Startup Summit: conheça a BlackBelt IT Solutions',
    ariaPrefix: 'Ler matéria',
    link: 'https://economiasc.com/2024/07/31/startup-summit-conheca-a-blackbelt-it-solutions-especialista-em-seguranca-da-informacao-e-privacidade-de-dados/',
  },
  {
    tag: 'Palestra',
    title: 'Ampass promove palestra sobre cibersegurança e os riscos da Inteligência Artificial no setor público',
    ariaPrefix: 'Ler notícia',
    link: 'https://reciprev.recife.pe.gov.br/ampass-promove-palestra-sobre-ciberseguranca-e-os-riscos-da-inteligencia-artificial-no-setor-0',
  },
];

export const finalCta = {
  tag: 'Diagnóstico Inicial',
  titleStart: 'Proteja sua Empresa com',
  titleHighlight: 'Segurança de Alto Nível',
  text:
    'Agende uma consulta gratuita com nossos especialistas para entender o nível de maturidade e como podemos fortalecer a proteção da sua organização.',
  options: [
    { icon: 'user', label: 'Reunião Presencial' },
    { icon: 'video', label: 'Videoconferência' },
    { icon: 'phone', label: 'Chamada Telefônica' },
  ],
  button: 'Agendar Avaliação',
};

export const footer = {
  about: 'Segurança da Informação, Privacidade de Dados e Cloud Services com estratégia de faixa preta e cobertura nacional.',
  social: [
    { icon: 'instagram', label: 'Instagram da BlackBelt IT Solutions', href: 'https://www.instagram.com/bbitsolutions' },
    { icon: 'youtube', label: 'Canal no YouTube da BlackBelt IT Solutions', href: 'https://www.youtube.com/c/BlackBeltItSolutions' },
    { icon: 'linkedin', label: 'LinkedIn da BlackBelt IT Solutions', href: 'https://www.linkedin.com/company/blackbelt-it-solutions/' },
  ],
  navItems: [
    { label: 'Início', href: '#inicio' },
    { label: 'Quem Somos', href: '#quem-somos' },
    { label: 'Soluções', href: '#solucoes' },
    { label: 'CyberSensei', href: '#cybersensei' },
    { label: 'Depoimentos', href: '#depoimentos' },
    { label: 'Na Mídia', href: '#midia' },
  ],
  contacts: {
    phone: { label: '+55 81 3049-7999', href: 'tel:+558130497999' },
    whatsapp: { label: '+55 81 99652-7732', href: 'https://wa.me/5581996527732' },
    email: { label: 'contato@bbitsolutions.com.br', href: 'mailto:contato@bbitsolutions.com.br' },
  },
  // Mesmo e-mail de DPO exibido pelo banner de privacidade do FácilLGPD.
  dpoEmail: 'dpo@bbitsolutions.com.br',
  addresses: [
    { unit: 'Unidade Recife', lines: ['R. do Cupim, 132 - Graças', 'Recife - PE, CEP: 52011-070'] },
    { unit: 'Unidade Camaragibe', lines: ['AV. Samuel Macdowell, 46 - Vila da Inabi', 'Camaragibe - PE, CEP: 54753-350'] },
  ],
};
